<template>
  <v-flex xs12 sm10 md8 class="addresses-wrap my-4">
    <v-card class="pa-2">
      <v-alert class="ma-2" color="error" icon="warning" v-if="err" :value="err !== ''">
        {{err}}
      </v-alert>
      <v-alert class="ma-2" color="success" icon="warning" v-if="success" :value="success !== ''">
        {{success}}
      </v-alert>
      <v-layout row wrap justify-start align-center>
          <v-flex xs12 sm6 pa-2>
            <v-text-field
                :label="$lang.labels.name"
                v-model="lastName"
            />
          </v-flex>
          <v-flex xs12 sm6 pa-2>
            <v-text-field
                :label="$lang.labels.phone"
                v-model="phone"
            />
          </v-flex>
      </v-layout>
      <div class="v-table__overflow ma-2" v-if="width > 599">
        <table class="v-datatable v-table">
          <thead>
          <tr>
            <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.postalCode }}</th>
            <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.address }}</th>
            <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.locality }}</th>
            <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.townCity }}</th>
            <th role="columnheader" scope="col" class="column text-xs-right actions"></th>
          </tr>
          <tr class="v-datatable__progress">
            <th colspan="100%" class="column"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(address, index) in currentAddresses" :key="index">
            <td class="text-xs-left">{{ address.postalCode }}</td>
            <td class="text-xs-left">{{ generateAddress([address.line1, address.line2, address.line3, address.line4])
              }}
            </td>
            <td class="text-xs-left">{{ address.locality }}</td>
            <td class="text-xs-left">{{ address.townCity }}</td>
            <td class="text-xs-right actions">
              <v-btn fab flat dark small color="primary" class="mx-0 mr-2" @click.stop="editAddress(address, index)">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn fab flat dark small color="primary" class="mx-0" @click.stop="deleteAddress(index)">
                <v-icon dark>delete</v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <v-layout row wrap justify-start align-start pa-2 v-if="width < 600">
        <template v-for="(address, index) in currentAddresses">
          <v-card hover min-width="100%" class="pa-4 my-1" :style="`background-color: ${goDark ? '#212121' : ''}`">
            <v-layout row wrap :key="index">
              <v-flex xs11>
                <p class="mb-0">{{ generateAddress([address.line1, address.line2, address.line3, address.line4]) }}</p>
                <p class="mb-0">
                  {{ company.address.locality ? company.address.locality + ', ' : '' }}
                  {{ company.address.country === 'UK' ? company.address.townCity : company.address.postalCode }},
                  {{ company.address.country === 'UK' ? company.address.postalCode : company.address.townCity }}
                </p>
              </v-flex>
              <v-flex xs1>
                <v-btn fab flat dark small color="primary" class="mx-0 mr-2" @click.stop="editAddress(address, index)">
                  <v-icon dark>edit</v-icon>
                </v-btn>
                <v-btn fab flat dark small color="primary" class="mx-0" @click.stop="deleteAddress(index)">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </template>
      </v-layout>
      <v-layout justify-space-between>
        <v-btn
            id="addAddress"
            class="primary ma-2"
            @click="addAddress">
          {{ $lang.actions.addAddress }}
        </v-btn>
        <v-btn
            id="submitAddresses"
            class="primary ma-2"
            @click="submit">
          {{ $lang.actions.submit }}
        </v-btn>
      </v-layout>
    </v-card>
    <v-dialog v-model="dialog" v-if="dialog" max-width="500px">
      <Address :address="addressToEdit" @close="closeDialog" @submit="submitAddress"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex';
  import auth from '@/auth';
  import Address from '@/components/webshop/modals/Address';

  export default {
    components: {
      Address,
    },
    data: () => ({
      lastName: '',
      dialog: false,
      err: '',
      success: '',
      currentAddresses: [],
      phone: null,
      addressToEdit: undefined,
    }),
    computed: mapGetters({
      contact: 'contact',
      addresses: 'addresses',
      addressesSet: 'addressesSet',
      width: 'width',
      company: 'company',
      goDark: 'goDark',
    }),
    methods: {
      addAddress() {
        this.dialog = true;
      },
      deleteAddress(index) {
        this.currentAddresses.splice(index, 1);
      },
      generateAddress(lines) {
        return lines.filter(line => !!line)
          .join(', ');
      },
      editAddress(address, index) {
        this.addressToEdit = address;
        this.addressIndex = index;
        this.dialog = true;
      },
      closeDialog() {
        this.addressToEdit = undefined;
        this.addressIndex = undefined;
        this.dialog = false;
      },
      submitAddress(payload) {
        const address = payload;
        const keys = Object.keys(payload);
        keys.forEach((key) => {
          if (!address[key]) delete address[key];
        });
        if (typeof this.addressIndex !== 'undefined') {
          this.currentAddresses[this.addressIndex] = address;
        } else {
          this.currentAddresses.push(address);
        }
        this.closeDialog();
      },
      submit() {
        if (!this.phone || this.phone === '') {
          this.err = this.$lang.errors.requiredPhone;
          return;
        }
        if (!this.lastName || this.lastName === '') {
          this.err = this.$lang.errors.requiredName;
          return;
        }
        if (this.lastName.length > 34) {
          this.err = this.$lang.errors.nameLess;
          return;
        }
        this.$webHelper.post('contact/update', {
          address: this.currentAddresses,
          phone: this.phone,
          lastName: this.lastName,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              this.err = this.$lang.errors.failedAddress;
              return;
            }
            this.$store.dispatch('setAddresses', this.currentAddresses);
            this.$store.dispatch('setContact', {
              lastName: this.lastName,
              phone: this.phone,
            });
            this.success = this.$lang.success.addressUpdated;
          });
      },
    },
    watch: {
      err() {
        setTimeout(() => {
          this.err = '';
        }, 3000);
      },
      success() {
        setTimeout(() => {
          this.success = '';
        }, 3000);
      },
    },
    created() {
      if (!auth.isLoggedIn()) {
        this.$router.push('/login');
        return;
      }
      if (this.addresses.length === 0 && !this.addressesSet) {
        this.$webHelper.get('contact/fetchforauser', null, this.$router)
          .then((res) => {
            if (!res.success) {
              this.err = this.$lang.errors.failedContactInfo;
              return;
            }
            this.currentAddresses = res.body.contact.address;
            this.phone = res.body.contact.phone;
            this.lastName = res.body.contact.lastName;
            this.$store.dispatch('setAddresses', this.currentAddresses);
            this.$store.dispatch('setContact', {
              lastName: this.lastName,
              phone: this.phone,
            });
          });
      } else if (this.addressesSet) {
        this.currentAddresses = this.addresses;
        this.phone = this.contact.phone;
        this.lastName = this.contact.lastName;
      }
    },
    destroyed() {
      this.currentAddresses = [];
      this.phone = null;
      this.lastName = '';
    },
  };
</script>

<style lang="scss" scoped>
  .addresses-wrap {
    margin: 0 auto;
    width: 100%;
    min-width: 300px;
    max-width: 992px;
  }

  .actions {
    max-width: 76px !important;
    padding: 0 6px 0 24px !important;
  }

  tbody tr td:last-child {
    width: 25%;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Addresses.vue